<template>
  <section class="zohoMea-section" id="features-section">
    <div class="video-pattern" data-aos="fade-up" data-aos-delay="200"></div>
    <!-- <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/pattern1.png'"
      alt="image not found"
      class="video-pattern1"
    /> -->
    <img width="160" height="160" loading="lazy" src="https://measiteassetpublic.zohostratus.in/footer/pattern1.png"
      alt="image not found"
      class="video-pattern1"
    />
    <!-- <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/message.svg'"
      alt="image not found"
      class="video-pattern2"
    /> -->
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div
            class="video-panel"
            data-aos="fade-up"
            data-aos-anchor-placement="top-center"
            data-aos-delay="100"
          >
            <span
              class="wrap-icon-play"
              data-bs-toggle="modal"
              data-bs-target="#videoPlay"
              :data-video="videoUrl"
              data-aos="zoom-in"
              data-aos-delay="300"
              @click="openVideo(videoUrl)"
            >
              <i class="bx bx-play"></i>
            </span>
            <!-- <img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/video.png'" alt="Image" /> -->
            <img width="927" height="528" loading="lazy" src="https://measiteassetpublic.zohostratus.in/designFiles/video.png" alt="Image" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="videoPlay" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header border-0">
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeVideo"
            ></button>
          </div>
          <div class="modal-body p-0">
            <div class="ratio ratio-16x9">
              <iframe :src="activeVideo" title="Video" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from "vue";

const videoUrl = "https://www.youtube.com/embed/GMniyQIc1eU";
const activeVideo = ref("");

function openVideo(url) {
  activeVideo.value = url;
}

function closeVideo() {
  activeVideo.value = "";
}
</script>
<script>
export default {
  name: "HomeFeatureSection",
};
</script>

<style>
</style>